/* eslint-disable */
// This file is automatically generated and should not be edited directly.
// Please edit the corresponding SVG file

import React from 'react';

const MoreWhiteV2 = (props: any) => (
<svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="none">
<circle cx="9" cy="9" r="8.25" stroke="black" strokeWidth="1.5"/>
<circle cx="5" cy="9" r="1" fill="black"/>
<circle cx="9" cy="9" r="1" fill="black"/>
<circle cx="13" cy="9" r="1" fill="black"/>
<path fillRule="evenodd" clipRule="evenodd" d="M16.149 13.4129C14.8131 14.2874 13.2159 14.7958 11.5 14.7958C6.80558 14.7958 3 10.9903 3 6.29584C3 4.29337 3.69245 2.45262 4.85097 1C2.53199 2.51789 1 5.13859 1 8.1171C1 12.8115 4.80558 16.6171 9.5 16.6171C12.1919 16.6171 14.5916 15.3657 16.149 13.4129Z" fill="black" fillOpacity="0.4"/>
</svg>);

export default MoreWhiteV2;